export default "__VITE_ASSET__oocwd1ve__"